<template>
  <div>
    <ul class="legend-items mt-4">
      <li class="legend-item">
        <v-icon
          size="small"
          :color="getAssetContainerStatusColor(AssetContainerEventType.Unloading)">
          {{ getAssetContainerStatusIcon(AssetContainerEventType.Unloading) }}
        </v-icon>
        <span class="text-caption">
          {{
            t('core.yard.assetContainerEvent.types.unloading', AssetContainerEventType.Unloading)
          }}
        </span>
      </li>
      <li class="legend-item">
        <v-icon size="small" :color="getAssetContainerStatusColor(AssetContainerEventType.Loading)">
          {{ getAssetContainerStatusIcon(AssetContainerEventType.Loading) }}
        </v-icon>
        <span class="text-caption">
          {{ t('core.yard.assetContainerEvent.types.loading', AssetContainerEventType.Loading) }}
        </span>
      </li>
      <li class="legend-item">
        <v-icon
          size="small"
          :color="getAssetContainerStatusColor(AssetContainerEventType.ReadyForPickup)">
          {{ getAssetContainerStatusIcon(AssetContainerEventType.ReadyForPickup) }}
        </v-icon>
        <span class="text-caption">
          {{
            t(
              'core.yard.assetContainerEvent.types.readyForPickup',
              AssetContainerEventType.ReadyForPickup
            )
          }}
        </span>
      </li>
      <li class="legend-item">
        <v-icon size="small" color="info">mdi-calendar</v-icon>
        <span class="text-caption">{{ t('yard.messages.pickupScheduled') }}</span>
      </li>
      <li class="legend-item">
        <v-btn
          @click="isDialogVisible = true"
          size="small"
          variant="text"
          data-testid="yard-legend-view-btn">
          {{ t('yard.buttons.viewAll') }}
        </v-btn>
      </li>
    </ul>
    <yard-view-legend-dialog :is-visible="isDialogVisible" @close="isDialogVisible = false" />
  </div>
</template>
<script>
import { defineComponent, ref } from 'vue';
import useYard from '@/modules/yard/composables/useYard';
import { LoadTypeDirection, SpotType, AssetContainerEventType } from '@nova/core';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardViewLegend',
  props: {},
  setup() {
    const yardStore = useYard();
    const { t } = useI18n();

    const isDialogVisible = ref(false);

    return {
      getAssetContainerStatusColor: yardStore.getAssetContainerStatusColor,
      getAssetContainerStatusIcon: yardStore.getAssetContainerStatusIcon,
      getSpotIcon: yardStore.getSpotIcon,
      getLoadTypeDirectionColor: yardStore.getLoadTypeDirectionColor,
      SpotType,
      isDialogVisible,
      AssetContainerEventType,
      LoadTypeDirection,
      t
    };
  }
});
</script>

<style scoped lang="scss">
.legend-items {
  display: flex;
  flex-flow: row wrap;
  gap: $spacing-3;

  justify-content: flex-end;

  margin: 0;
  padding: 0;
}

.legend-item {
  display: flex;
  flex-direction: row;
  gap: $spacing-1;

  align-items: center;
}
.v-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  inline-size: 16px;
  block-size: 16px;

  font-size: 10px;
}

.appointment-icon,
.no-appointment-icon {
  display: inline-block;
  inline-size: 10px;
  block-size: 10px;
  margin: 3px;
  border-radius: 2px;

  border-width: 1px;
  border-style: solid;
}

.appointment-icon {
  background-color: $color-accent-20;
  border-color: $color-accent-60;
}

.no-appointment-icon {
  background-color: $color-neutral-20;
  border-color: $color-neutral-60;
}
</style>
